import currency from "currency.js"
export const fnFormatNumb = (value = 0) => currency(value, {symbol: ""}).format()